












































































































// Vue
import { defineComponent, PropType, computed, ref, Ref, onMounted } from '@vue/composition-api'

// components
import { Form, Input, Button, Icon, DatePicker, Select2 } from '@/components/general'
import { Loading } from '@/components'
import { Radio } from '@/components/form'

// models
import { PropOptionSelect } from '@/models'
import { BondControlForm } from '@/models/dailyControl'
import { BondType, IEmployee } from '@/models/config'

// services
import { EmployeeService, BondTypesService } from '@/services/config'
import { BondControlService } from '@/services/dailyControl'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required, requiredIf, minValue } from '@vuelidate/validators'

// utils
import { alerts, loading, getFullNameFormat, dateLibs } from '@/utils'
import { getListDateAvailable } from '@/utils/employee'

// constants
import { optionsStatus } from '@/constants'

export default defineComponent({
  name: 'BondControlFormCreateEdit',
  components: {
    Form,
    Input,
    Button,
    Icon,
    DatePicker,
    Select2,
    Loading,
    Radio
  },
  props: {
    item: {
      type: Object as PropType<BondControlForm>,
      required: true
    },
    idEdit: {
      type: Number as PropType<number>,
      default: null
    },
    action: {
      type: String as PropType<'save'|'update'>,
      required: true
    }
  },
  setup (props, { emit }) {
    const isLoading = ref(true)
    const typeForm = ref(1)
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault

    const rules = computed(() => ({
      item: {
        employee_id: {
          required: requiredIf(() => props.action !== 'save' || typeForm.value === 1),
          minValue: minValue(1)
        },
        bond_type_id: { required, minValue: minValue(1) },
        year: { required, minValue: minValue(1) },
        month: { required, minValue: minValue(1) },
        fortnight: { required, minValue: minValue(1) },
        amount: { required }
      }
    }))
    const $v = useVuelidate(rules, {
      item: props.item
    })

    const allEmployees: Ref<IEmployee[]> = ref([])
    const dateAvailable: Ref<string[]> = ref([])

    const employeesOp = computed(() => {
      return allEmployees.value
      .map(employee => ({
        value: employee.id || null,
        text: getFullNameFormat(employee)
      }))
    })

    const employeeSelected = computed(() => {
      if (props.item.employee_id && employeesOp.value.find(employee => employee.value === props.item.employee_id)) {
        const employee = allEmployees.value.find(e => e.id === props.item.employee_id)
        if (employee) {
          return employee
        }
      }
      return null
    })

    const allBondTypes: Ref<BondType[]> = ref([])
    const bondTypesOp: Ref<PropOptionSelect[]> = ref([])
    const loadingTypes = ref(false)
    const bondTypeDefault: Ref<null | number> = ref(null)

    const getAllBondType = async () => {
      allBondTypes.value = await BondTypesService.getActivated()
      if (props.action === 'update') {
        bondTypeDefault.value = props.item.bond_type_id
      }
    }

    const allBondTypesOp = computed(() => {
      return allBondTypes.value.map(type => ({
        value: type.id ?? null,
        text: type.name
      }))
    })

    const setListDateAvailable = () => {
      if (props.item.employee_id && employeeSelected.value) {
        const listDate = getListDateAvailable(employeeSelected.value.cessation)
        dateAvailable.value = listDate
      }
    }

    onMounted(async () => {
      allEmployees.value = await EmployeeService.getActivated()
      getAllBondType()
      isLoading.value = false
    })

    const save = async () => {
      $v.value.item.$touch()
      if (!$v.value.item.$invalid) {
        try {
          loading('show')
          const employee = allEmployees.value.find(e => Number(e.id) === Number(props.item.employee_id))
          const assignment = employee?.assignment

          if (employee && assignment) {
            if (props.action === 'save') {
                await BondControlService.create({
                  ...props.item,
                  headquarter_id: assignment?.headquarter_id,
                  area_id: assignment?.area_id,
                  sub_area_id: assignment.sub_area_id,
                  loaded_massive: false,
                  abstents_first_week: 0,
                  abstents_second_week: 0
                })
            } else {
              await BondControlService.update(props.idEdit, {
                  ...props.item,
                  headquarter_id: assignment?.headquarter_id,
                  area_id: assignment?.area_id,
                  sub_area_id: assignment.sub_area_id,
                  loaded_massive: false,
                  abstents_first_week: 0,
                  abstents_second_week: 0
                })
            }
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error(String(e))
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }

    return {
      save,
      $v,
      employeesOp,
      isLoading,
      setListDateAvailable,
      dateAvailable,
      employeeSelected,
      bondTypesOp,
      optionsStatus,
      loadingTypes,
      typeForm,
      years,
      months,
      fortnights,
      allBondTypesOp
    }
  }
})
